import { pipe } from '@helo/utils'

import { Options } from '../../Options'
import { RenderPipeline } from '../../RenderPipeline'
import { ChartDataParts } from '../ChartData/ChartData.parts'
import type { ChartReferenceLineItem } from './ChartReferenceLine.options'
import { chartReferenceLineOptions } from './ChartReferenceLine.options'

/** Resolve root input: override, then content-node state, then defaults. */
const setupInput = () =>
  RenderPipeline.updateInput((input, ctx) =>
    pipe(
      input,
      Options.fallback(
        chartReferenceLineOptions,
        ChartDataParts.getChartState()(ctx),
      ),
      Options.applyDefaults(chartReferenceLineOptions),
      Options.validate(chartReferenceLineOptions),
    ),
  )

/** Apply defaults to each `_referenceLines` item. */
const setup_referenceLinesInput = () =>
  RenderPipeline.updateInput(input => ({
    ...input,
    _referenceLines: (input._referenceLines ?? []).map(line =>
      pipe(line, Options.applyDefaults(chartReferenceLineOptions)),
    ),
  }))

const setReferenceLines = () =>
  RenderPipeline.updateOutput(
    (
      _output: { referenceLines?: ChartReferenceLineItem[] },
      ctx: { input: { _referenceLines?: ChartReferenceLineItem[] } },
    ) => ({
      referenceLines: ctx.input._referenceLines ?? [],
    }),
  )

export const ChartReferenceLineInputParts = {
  setupInput,
  setup_referenceLinesInput,
}

export const ChartReferenceLineOutputParts = {
  setReferenceLines,
}
